export const noRetryRoutes = new Set([
    "/cash-balance/last-cash-balance",
    "/transaction-reversal",
    "/cash-movement",
    "/sold-items",
    "/store-exchange",
    "/store-deposit-option",
    "/store-deposit-maintenance",
    "/store-invoice"
]);

export function shouldNotRetry(url: string): boolean {
    return [...noRetryRoutes].some(route => url.includes(route));
}
